import { lazy, type ComponentType } from 'react'
import { region as currentRegion, type Region } from '@/config/locales'

type ModuleLoader<P> = () => Promise<{ default: ComponentType<P> }>

// Only the active region's chunk is ever downloaded.
export function regionLazy<P>(
  loaders: Record<Region, ModuleLoader<P>>,
  region: Region = currentRegion
) {
  return lazy(loaders[region])
}
